import _isEmpty from "lodash/isEmpty";
import React from 'react';
import { getBottomLine, getDisclaimer, getQualificationsBullets } from '@nerdwallet/marketplace/selectors/common';
import { getFeesBullets } from '@nerdwallet/marketplace/selectors/personal-loans';
import { getAvailableTermLengths } from '@nerdwallet/marketplace/utils/loans';
import { mappings as quickFactMappings } from '@nerdwallet/react-quick-facts';
import Qualifications from '../loans-qualifications';
import { CONTENT_TABS } from '../lib/constants';
export default (function (_ref) {
  var bottomLine = _ref.bottomLine,
    marketplaceEntity = _ref.marketplaceEntity;
  var qualifications = getQualificationsBullets(marketplaceEntity);
  var disclaimer = getDisclaimer(marketplaceEntity);
  var fees = getFeesBullets(marketplaceEntity);
  var terms = getAvailableTermLengths(marketplaceEntity);
  return {
    activeContentTab: CONTENT_TABS.KEY_FACTS,
    bottomLine: null,
    drivers: [quickFactMappings.personalLoans.getQuickFactMinCreditScore(marketplaceEntity), quickFactMappings.personalLoans.getQuickFactEstimatedAPR(marketplaceEntity), quickFactMappings.personalLoans.getQuickFactLoanAmount(marketplaceEntity)],
    keyFacts: bottomLine || getBottomLine(marketplaceEntity),
    productDetails: !_isEmpty(qualifications) || disclaimer ? /*#__PURE__*/React.createElement(Qualifications, {
      bullets: qualifications,
      feesBullets: fees,
      disclaimer: disclaimer,
      termLengths: terms
    }) : null
  };
});